import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import logo from 'assets/images/plus-logo.svg';
import IconButton from '../../common/IconButton';
import SideNavItem from './SideNavItem';
import SideNavItemExternal from './SideNavItemExternal';
import { ADD_BETSLIP, BETTING_BUDDY, COOKIE, HOME, LINK_ACCOUNT, OPEN_BETS, REGISTER, RESPONSIBLE_GAMBLING, SETTINGS, SETTLED_BETS, SUPPORT, TERMS } from '../../../routes/paths';
import { PODCAST, SHOP_LOCATOR } from '../../../routes/externalLinks';
import { isOmniLinked } from '../../../modules/account/selectors';
import packageJson from '../../../../package.json';

const { version } = packageJson;

const SideNav = ({ authorized, pathname, authenticated, clickLink, clickLogout, logOut, omniLinked, push, toggle }) => {
  const blockClicks = event => {
    event.stopPropagation();
  };

  const internalLink = ({ path, name, source }) => {
    clickLink({ path, name, source });
    push(path);
  };

  return (
    <nav className="side-nav" onClick={blockClicks} data-test-id="side-nav">
      <header className="side-nav__header">
        <IconButton
          iconClassName="material-icon material-icon--close side-nav__close"
          onClick={() => toggle('nav')}
        />
      </header>
      <div className="side-nav__logo-container">
        <img className="side-nav__logo" src={logo} role="presentation" />
      </div>
      <div className="side-nav__content">
        <div className="side-nav__headline">Manage in-shop bets</div>
        <div className="side-nav__horizontal-buttons">
          <SideNavItem
            text="Open"
            iconClassName="icon icon--open-bets"
            onClick={() => internalLink({
              path: OPEN_BETS,
              name: 'Open',
              source: 'TopIcons'
            })}
            active={pathname.startsWith(OPEN_BETS)}
            disabled={!authorized}
            iconName="open-bets"
          />
          <SideNavItem
            text="Settled"
            iconClassName="icon icon--settled-bets"
            onClick={() => internalLink({
              path: SETTLED_BETS,
              name: 'Settled',
              source: 'TopIcons'
            })}
            active={pathname.startsWith(SETTLED_BETS)}
            disabled={!authorized}
            iconName="settled-bets"
          />
          <SideNavItem
            text="Add"
            iconClassName="icon icon--add"
            onClick={() => internalLink({
              path: ADD_BETSLIP,
              name: 'Add',
              source: 'TopIcons'
            })}
            active={pathname.startsWith(ADD_BETSLIP)}
            disabled={!authorized}
            iconName="add"
          />
        </div>
        <SideNavItem
          iconClassName="icon icon--home"
          text="Home"
          onClick={() => internalLink({
            path: HOME,
            name: 'Home',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(HOME)}
          iconName="home"
        />
        <SideNavItem
          iconClassName="icon icon--account"
          text="Account"
          onClick={() => internalLink({
            path: SETTINGS,
            name: 'Account',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(SETTINGS)}
          disabled={!authenticated}
          iconName="account"
        />
        <SideNavItem
          iconClassName="icon icon--betting-buddy"
          text="Create a Slip"
          onClick={() => internalLink({
            path: BETTING_BUDDY,
            name: 'CreateASlip',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(BETTING_BUDDY)}
          labelNewUntil={new Date(Date.UTC(2018, 8, 30, 23, 59, 59))}
          iconName="betting-buddy"
        />
        <SideNavItem
          text="Link Account"
          iconClassName="icon"
          onClick={() => internalLink({
            path: LINK_ACCOUNT,
            name: 'LinkAccount',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(LINK_ACCOUNT)}
          visible={authenticated && !omniLinked}
          iconName="link"
        />
        <SideNavItem
          text="Register"
          iconClassName="icon"
          onClick={() => internalLink({
            path: REGISTER,
            name: 'Register',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(REGISTER)}
          visible={authenticated && !omniLinked}
          iconName="register"
        />
        <SideNavItemExternal
          text="Stripped Podcast"
          iconClassName="icon icon--podcast"
          link={PODCAST}
          onClick={() => clickLink({
            path: PODCAST,
            name: 'Podcasts',
            source: 'LeftLinks'
          })}
          iconName="podcast"
        />
        <SideNavItem
          text="Support and Contacts"
          iconClassName="icon icon--question-mark"
          onClick={() => internalLink({
            path: SUPPORT,
            name: 'SupportAndContacts',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(SUPPORT)}
          iconName="question-mark"
        />
        <SideNavItemExternal
          text="Shop Locator"
          iconClassName="icon icon--pin"
          link={SHOP_LOCATOR}
          onClick={() => clickLink({
            path: SHOP_LOCATOR,
            name: 'ShopLocator',
            source: 'LeftLinks'
          })}
          iconName="pin"
        />
        <SideNavItem
          text="Terms and Cookie Policy"
          iconClassName="icon icon--info"
          onClick={() => internalLink({
            path: TERMS,
            name: 'TermsAndCookiePolicy',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(TERMS) || pathname.startsWith(COOKIE)}
          iconName="info"
        />
        <SideNavItem
          text="Responsible Gambling"
          iconClassName="icon icon--bookmark"
          onClick={() => internalLink({
            path: RESPONSIBLE_GAMBLING,
            name: 'ResponsibleGambling',
            source: 'LeftLinks'
          })}
          active={pathname.startsWith(RESPONSIBLE_GAMBLING)}
          iconName="bookmark"
        />
        <SideNavItem
          text="Logout"
          iconClassName="material-icon material-icon--exit"
          onClick={() => {
            clickLogout({ name: 'LogOut', source: 'LeftLinks' });
            logOut();
          }}
          disabled={!authorized}
        />
      </div>
      <footer className="side-nav__footer">
        {version}
      </footer>
    </nav>
  );
};

SideNav.propTypes = {
  authorized: PropTypes.bool,
  pathname: PropTypes.string,
  authenticated: PropTypes.bool,
  clickLink: PropTypes.func,
  clickLogout: PropTypes.func,
  logOut: PropTypes.func,
  omniLinked: PropTypes.bool,
  push: PropTypes.func,
  toggle: PropTypes.func
};

const mapStateToProps = state => ({
  omniLinked: isOmniLinked(state),
});

export default connect(mapStateToProps)(SideNav);
